// removed by extract-text-webpack-plugin
module.exports = {"arrow":"style__arrow___17ZTp","breadcrumbs-container":"style__breadcrumbs-container___onvtv","breadcrumb-list":"style__breadcrumb-list___3xhVZ"};


//////////////////
// WEBPACK FOOTER
// ./components/Breadcrumbs/style.scss
// module id = 1217
// module chunks = 0